import { useCallback, useState } from 'react';
import { PageableResponse } from '../../../models/response.model';
import {
  IProdutoEscolaFullDTO,
} from '../../../models/happy-code-api.model';
import { useProdutoEscolaService } from '../../../services/produto-escola.service';
import useAddPredicateOnQueryParam from './use-add-predicate-on-query-param.hook';
import { useGlobalContext } from '../../../context/GlobalContext';
import { useHandlePageChangeHook } from '../../../hooks/use-handle-page-change.hook';
import { useUnidadeService } from '../../../services/unidade.service';

export default function useFindProductStemplay() {
  const produtoService = useProdutoEscolaService();
  const onPageChange = useHandlePageChangeHook();
  const { addPredicateOnQueryParam } = useAddPredicateOnQueryParam();
  const { usuario, unidade } = useGlobalContext();
  const { acessoB2b } = usuario || {};
  const unidadeService = useUnidadeService();

  const [productStemplay, setProductStemplay] =
    useState<PageableResponse<IProdutoEscolaFullDTO>>();


 const findTipoUnidadeByUnidadeId = useCallback(async (): Promise<number> => {

    return unidadeService
      .findById({ id: unidade?.id })
      .then(({ data }) => {
        return data.tipoUnidade.id;
      })
  }, [unidade]);

  const findProductStemplay = useCallback(
    async (page?: number): Promise<void> => {
      if (!acessoB2b) return;
      const tipoUnidadeId = await findTipoUnidadeByUnidadeId();
      const predicate = addPredicateOnQueryParam(page);
    

      await produtoService 
        .stemplayProduto(unidade?.id, tipoUnidadeId, predicate)
        .then(({ data }) => setProductStemplay(data));
    },
    [acessoB2b, addPredicateOnQueryParam],
  );

  return {
    productStemplay: {
      data: productStemplay,
      getData: findProductStemplay,
      onPageChange: onPageChange(findProductStemplay),
    },
  };
}
